import { useContext } from 'react';
import { AbilityContext } from './index';

/**
 * Хук для проверки Helpdesk-specific permissions.
 *
 * Permissions приходят с бэка в формате:
 *   { ticket: ["hd_view_all_tickets", "hd_manage_tickets", "hd_manage_settings", ...] }
 *
 * CASL маппит их как: can('hd_manage_tickets', 'ticket')
 * Суперюзер имеет can('manage', 'all') — он проходит все проверки.
 */
export function useHdPermissions() {
  const ability = useContext(AbilityContext);

  return {
    /** Видит все тикеты (админ, руководитель ТП, lead operator) */
    canViewAllTickets: ability.can('hd_view_all_tickets', 'ticket') || ability.can('manage', 'all'),

    /** Может управлять тикетами (назначать, менять статус, отвечать) */
    canManageTickets: ability.can('hd_manage_tickets', 'ticket') || ability.can('manage', 'all'),

    /** Может настраивать Helpdesk (маршрутизация, SLA, расписания и т.д.) */
    canManageSettings: ability.can('hd_manage_settings', 'ticket') || ability.can('manage', 'all'),

    /** Может управлять операторами */
    canManageOperators: ability.can('hd_manage_operators', 'ticket') || ability.can('manage', 'all'),

    /** Может добавлять внутренние заметки */
    canAddInternalNote: ability.can('hd_add_internal_note', 'ticket') || ability.can('manage', 'all'),

    /** Может смотреть отчёты */
    canViewReports: ability.can('hd_view_reports', 'ticket') || ability.can('manage', 'all'),

    /** Может переназначать тикеты */
    canReassignTicket: ability.can('hd_reassign_ticket', 'ticket') || ability.can('manage', 'all'),

    /** Является ли пользователь HD-оператором/админом (общая проверка) */
    isHdStaff:
      ability.can('hd_manage_tickets', 'ticket') ||
      ability.can('hd_view_all_tickets', 'ticket') ||
      ability.can('manage', 'all'),
  };
}
